import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  saving = false;

  constructor(private formBuilder: FormBuilder, private apiService: ApiService) { }

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmNewPassword: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  showErr(name: string, error: string): boolean {
    const c = this.changePasswordForm.get(name);
    return !!c && c.hasError(error) && (c.dirty || c.touched);
  }

  get mismatch(): boolean {
    const n = this.changePasswordForm.get('newPassword');
    const c = this.changePasswordForm.get('confirmNewPassword');
    return !!n && !!c && c.value !== n.value && (c.dirty || c.touched);
  }

  onSubmit() {
    if (!this.changePasswordForm.valid || this.mismatch) { return; }

    const email = localStorage.getItem('email');
    const oldPassword = this.changePasswordForm.value.oldPassword;
    const newPassword = this.changePasswordForm.value.newPassword;

    this.saving = true;
    this.apiService.changePassword(email, oldPassword, newPassword).subscribe(
      response => {
        this.saving = false;
        if (response.status == 'Failed') {
          alert(response.message);
        } else {
          alert('Password changed successfully.');
        }
        this.changePasswordForm.reset({ oldPassword: '', newPassword: '', confirmNewPassword: '' });
      },
      () => {
        this.saving = false;
        alert('Could not change password');
      }
    );
  }

  cancelSubscription() {
    if (!confirm('Are you sure you want to cancel your subscription?')) { return; }

    const id = localStorage.getItem('user_id');
    const agrement_id = localStorage.getItem('agrement_id');
    const user_id = parseInt(id, 10);

    this.apiService.cancelSubscription(user_id, agrement_id).subscribe(
      (response) => {
        if (response.status == 'Failed') {
          alert(response.message);
        } else {
          alert('Subscription cancelled');
        }
      },
      () => alert('Could not cancel subscription')
    );
  }
}
